import { SimplifiedUserRole, ProgressStepStatusEnum } from '@platform/client/schemas';
import { ControlledAccordion, Icon } from '@platform/components';
import cx from 'classix';

type BaseAccordionStepProps = {
  title: string;
  status: ProgressStepStatusEnum;
  children?: React.ReactNode;
  finalStep?: boolean;
};

export const AccordionStep = ({
  children,
  title,
  status,
  finalStep = false,
}: BaseAccordionStepProps) => {
  return (
    <ControlledAccordion
      type='custom'
      title={title}
      className={cx('h-[72px] px-4 bg-white', !finalStep && 'border-b border-gray-100')}
      isBorderless
      leftContent={
        (status === ProgressStepStatusEnum.success && (
          <Icon additionalClassNames='text-success-500' type='check-circle' />
        )) ||
        ((status === ProgressStepStatusEnum.active_in_progress ||
          status === ProgressStepStatusEnum.inactive_in_progress) && (
          <Icon additionalClassNames='text-warning-500' type='alert-circle' />
        )) ||
        (status === ProgressStepStatusEnum.not_started && (
          <Icon additionalClassNames='text-gray-400' type='lock-01' />
        )) ||
        (status === ProgressStepStatusEnum.failure && (
          <Icon additionalClassNames='text-gray-400' type='slash-circle-01' />
        ))
      }
      isOpen={
        status === ProgressStepStatusEnum.inactive_in_progress ||
        status === ProgressStepStatusEnum.active_in_progress ||
        status === ProgressStepStatusEnum.failure
      }
    >
      <div
        className={cx(
          'bg-gray-50 px-8 py-6 flex flex-col gap-4 border-gray-100',
          finalStep ? 'border-t border-gray-100' : 'border-b',
        )}
      >
        {children}
      </div>
    </ControlledAccordion>
  );
};

/** Progress tracker accordions specific props */
export type ProgressAccordionStepProps = {
  status: ProgressStepStatusEnum;
  userType: SimplifiedUserRole;
  isTeam?: boolean;
};
